
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.882 19c.737 0 1.334-.554 1.334-1.237L9.215 4.224l4.509 4.182a1.408 1.408 0 001.885-.001 1.174 1.174 0 000-1.75L8.825.363A1.385 1.385 0 007.882 0C7.541 0 7.2.12 6.94.362L.39 6.438a1.175 1.175 0 000 1.75c.52.482 1.366.482 1.886 0l4.272-3.964v13.539c0 .683.598 1.237 1.334 1.237z","fill":"#2D71A6","fill-rule":"evenodd"}})])
          )
        }
      }
    